import React, { useMemo } from "react";
import { Select, SelectProps } from "antd";
import { useQuery } from "react-query";
import { startCase } from "lodash-es";
import { fetchInventoryChannels } from "../../api/fulfillment/product";
import { SelectValue } from "antd/lib/select";

interface SelectSalesChannelProps extends SelectProps<SelectValue> {
  orgId: string;
  showAllOption?: boolean;
  fallbackOptions?: SelectProps<SelectValue>["options"];
}

export const titleCase = (text: string) =>
  text
    .split(" ")
    .map((i) => startCase(i).replace(/\s/g, ""))
    .join(" ");

export const SelectSalesChannel: React.FC<SelectSalesChannelProps> = (props) => {
  const { data: channels = [] } = useQuery(["channels", props.orgId], () => fetchInventoryChannels(props.orgId), {
    enabled: !!props.orgId,
    select({ data }) {
      let options = data.map((d) => ({ value: d.name, label: titleCase(d.name) }));
      if (props.showAllOption) options = [{ value: "all", label: "All Channels" }, ...options];
      return options;
    },
  });

  const options = useMemo(() => {
    if (channels.length > 0) return channels;
    return props.fallbackOptions || [];
  }, [channels, props.fallbackOptions]);

  if (options.length === 0) return null;
  return <Select style={{ width: "100%" }} dropdownStyle={{ minWidth: 200 }} options={options} {...props} />;
};
